module.exports = __webpack_public_path__ + "img/icon-input.896e4864.png";